import Seo from "../components/Seo";
import PricingPreview from "../components/sections/PricingPreview";
import FAQ from "../components/sections/FAQ";
import FinalCTA from "../components/sections/FinalCTA";

export default function Pricing() {
    return (
        <main data-testid="pricing-page" className="min-h-screen">
            <Seo
                title="Pricing"
                path="/pricing"
                description="ezBuildABot pricing — every project is scoped and fixed-price after a free 30-minute call. Blueprint Call $297, Starter Bot from $2,500, Custom App from $7,500. No hourly billing, no scope-creep invoices, no surprises."
            />            <div className="relative pt-32 sm:pt-40 pb-12">
                <div className="absolute inset-0 radial-glow pointer-events-none" />
                <div className="relative max-w-4xl mx-auto px-6 sm:px-10 lg:px-16 text-center">
                    <span className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#00f0ff]">
                        Pricing
                    </span>
                    <h1 className="font-heading text-5xl sm:text-7xl font-black tracking-tighter mt-4 leading-[0.95]">
                        Real pricing.{" "}
                        <span className="text-gradient-cyan">No runaround.</span>
                    </h1>
                    <p className="text-lg text-[#94a3b8] mt-7">
                        Every project is scoped and fixed-price after a free 30-minute call. No
                        hourly billing, no scope-creep invoices, no surprises. Here&apos;s where
                        most builds land.
                    </p>
                </div>
            </div>

            <PricingPreview standalone />
            <FAQ />
            <FinalCTA />
        </main>
    );
}
